/* eslint-disable  @typescript-eslint/no-explicit-any */
import classNames from 'classnames';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { RadarChart } from 'echarts/charts';
import { EChartsOption } from 'echarts-for-react/lib/types';
import React from 'react';
import { Assessment } from './DataDefinitions';

const RadarChartWidget = ({
    data,
    className,
}: { data: Assessment | undefined, className?: string }) => {
    if (data === undefined || data === null) return (<>
        No available data
    </>)

    const questionarie = JSON.parse(data.assessment);

    const indicators: { text: string; max: number; }[] = []
    const selfEvaluation: number[] = []
    const expectedLevels: number[] = []
    questionarie.forEach((item: { competence: string; evaluation: number; expected_level: number }) => {
        indicators.push({ text: item.competence, max: 100 });
        selfEvaluation.push(item.evaluation);
        expectedLevels.push(item.expected_level);
    });

    echarts.use([RadarChart]);
    const option: EChartsOption = {
        color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],

        legend: {
            bottom: '0',
            // Set the top and bottom paddings to be 5, and left and right paddings to be 10
            padding: [10, 10]
        },
        radar: [
            {
                indicator: indicators,
                //center: ['25%', '50%'],
                radius: 120,
                startAngle: 90,
                splitNumber: 4,
                //backgroundColor: '#fff',
                shape: 'circle',
                axisName: {
                    formatter: '{value}',
                    color: '#428BD4'
                },
                splitArea: {
                    areaStyle: {
                        color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                        shadowColor: 'rgba(0, 0, 0, 0.2)',
                        shadowBlur: 10
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(211, 253, 250, 0.8)'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(211, 253, 250, 0.8)'
                    }
                }
            }
        ],
        series: [
            {
                type: 'radar',
                data: [
                    {
                        value: expectedLevels,
                        name: 'Expected'
                    },
                    {
                        value: selfEvaluation,
                        name: 'Self-rated',
                        areaStyle: {
                            color: 'rgba(255, 228, 52, 0.6)'
                        }
                    }
                ]
            }
        ]
    };



    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        //const formData = new FormData(event.currentTarget);
        //const reflections = formData.get("reflections") as string;

        // store data to server
        // close modal


    }



    return (
        <div className={classNames(className, 'w-100')}>

            <ReactEChartsCore
                echarts={echarts}
                option={option}
                style={{ minHeight: '400px', width: '100%' }}
            />

        </div>
    );
};

export default RadarChartWidget;
